import Vue from 'vue'
import Router from 'vue-router'
import QuickGuide from '@/components/QuickGuide'
import APAGenerator from '@/components/generator/genAPA'
import MLAGenerator from '@/components/generator/genMLA'
import ChicagoGenerator from '@/components/generator/genChicago'
import VancouverGenerator from '@/components/generator/genVancouver'

Vue.use(Router)

export default new Router({
    mode: "history",
    routes: [
        {
            path: '/apa-citation-generator/',
            name: 'cite-apa-main',
            component: APAGenerator
        },
        {
            path: '/mla-citation-generator/',
            name: 'cite-mla-main',
            component: MLAGenerator
        },
        {
            path: '/chicago-citation-generator/',
            name: 'cite-chicago-main',
            component: ChicagoGenerator
        },
        {
            path: '/vancouver-citation-generator/',
            name: 'cite-vancouver-main',
            component: VancouverGenerator
        },
        {
            path: '/citation-guide/:style',
            name: 'cite-guide',
            component: QuickGuide
        },
        {
            path: '*',
            name: 'cite-home',
            component: APAGenerator
        },

    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js